/* eslint-disable react/jsx-curly-newline */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable import/no-unresolved */
/* eslint-disable react/prop-types */
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
// components
import { Grid } from '@design-system-coopeuch/web';
import SimpleCard from '../../molecules/SimpleCard/SimpleCard';
import DetailsTable from '../../molecules/DetailsTable/DetailsTable';
import Modal from '../../organisms/Modal/Modal';
// assets
import { StyledButton } from '../../../assets/styles/styles';
import iconStamp from '../../../assets/img/icon-stamp.svg';
import iconStart from '../../../assets/img/icon-start.svg';

const CardVoucher = (props) => {
  const {
    email,
    detailData,
    monthlyFees,
    amountMonthlyFees,
    transactionDateTimeLong,
    isMobileDevice,
    isOpenModalVoucherDetail,
    openModalVoucherDetail,
    closeModalVoucherDetail,
    onDownloadComponentPdf,
    onCallSurvey,
  } = props;

  const refVoucher = useRef(null);

  return (
    <section id="voucherComponent" ref={refVoucher}>
      <SimpleCard
        contentHeader={
          <section className="d-flex justify-content-between align-items-center w-100">
            <article className="d-flex flex-column flex-grow-1">
              <p className="simplecard__title">Tu contratación</p>
            </article>
            <button
              type="button"
              onClick={() => onCallSurvey()}
              disabled={false}
              className="mr-2 d-flex align-items-center"
            >
              <img src={iconStart} width="20" height="20" alt="download icon" />
              {!isMobileDevice && <span className='ml-1 text-color-red-coopeuch font-size-14 font-weight-500'>Danos tu opinión</span>}
            </button>
            <StyledButton
              className="w-auto p-0 min-height-32"
              type="button"
              onClick={() =>
                onDownloadComponentPdf(/* refVoucher */ 'voucherComponent', 'comprobante')
              }
              disabled={false}
              prefix="line-download-2"
              variant="text"
              sizeIcon="18"
            >
              {!isMobileDevice && 'Descargar'}
            </StyledButton>
          </section>
        }
        disabled={false}
      >
        <Grid className="px-0 pb-2 d-flex flex-column">
          <Grid className="p-4 px-md-6 py-4 d-flex bg-secondary-blue-40 justigy-content-start">
            <article className="flex-basis-200">
              <p className="text-color-white">Monto pagado</p>
              <p className="text-color-white font-size-28 line-height-38">{amountMonthlyFees}</p>
            </article>
            <article className="">
              <p className="text-color-white">Cuotas pactadas</p>
              <p className="text-color-white font-size-28 line-height-38">{monthlyFees}</p>
            </article>
          </Grid>

          <Grid className="p-4 px-md-6 py-4 border-bottom border-neutral-20">
            <section className="d-flex flex-column flex-md-row align-items-start align-items-md-center flex-wrap">
              <p className="text-color-38 font-size-18 font-weight-bold line-height-24 mr-2 pb-1">
                Comprobante de pago
              </p>
              <StyledButton
                className={`font-size-14 px-0 max-width-200 ${
                  isMobileDevice ? 'justify-content-start' : 'justify-content-center'
                }`}
                disabled={false}
                onClick={openModalVoucherDetail}
                variant="text"
              >
                Ver detalle
              </StyledButton>
            </section>
            <p className="pb-2">
              {`Eres socio con ${monthlyFees} cuotas de participación pactadas.`}
            </p>
          </Grid>
          <Grid className="p-4 px-md-6 d-flex flex-column flex-md-row justify-content-between">
            <article className="d-flex flex-column justify-content-center">
              <p className="line-height-20">
                Se envió una copia de este comprobante a: <strong>{email}</strong>
              </p>
              <p className="line-height-20">
                Fecha y hora: <strong>{transactionDateTimeLong}.</strong>
              </p>
            </article>
            <article className="d-flex align-items-center flex-row flex-md-row-reverse">              
              <img
                className={`${!isMobileDevice ? 'img-stamp' : ''} mr-2 mr-md-0 ml-0 ml-md-2`}
                src={iconStamp}
                width="100px"
                height="100px"
                alt="stamp-icon"
              />
              <p className="font-size-12 text-color-A5">Transferencias 100% seguras</p>
            </article>
          </Grid>
        </Grid>
      </SimpleCard>
      {Object.keys(detailData).length > 0 && (
        <Modal
          isOpen={isOpenModalVoucherDetail}
          closeModal={closeModalVoucherDetail}
          unableToClose
          // closeClickOutside
          // closeEscKey
          id="modalAccountDetails"
        >
          <section className="d-flex flex-column width-lg-840px h-100">
            <Grid className="p-0 m-0 px-6 py-4 d-flex justify-content-between">
              <p className="font-size-24 line-height-30 font-weight-bold">Comprobante de pago</p>
              <StyledButton
                className="w-auto p-0 min-height-32"
                type="button"
                onClick={() =>
                  onDownloadComponentPdf('modalAccountDetails', 'detalle-comprobante')
                }
                disabled={false}
                prefix="line-download-2"
                variant="text"
                sizeIcon="18"
              >
                {!isMobileDevice && 'Descargar'}
              </StyledButton>
            </Grid>
            <Grid
              row
              className="p-0 m-0 justify-content-between align-items-center flex-1-1-auto overflow-auto"
            >
              <DetailsTable
                className={classNames('details-voucher')}
                head={detailData.tableFees.head}
                body={detailData.tableFees.body}
                gridTemplateColumns="2fr 3fr"
                underlined
                striped
              />
              <DetailsTable
                className={classNames('details-voucher')}
                head={detailData.tableAccount.head}
                body={detailData.tableAccount.body}
                gridTemplateColumns="2fr 3fr"
                underlined
                striped
                tooltip={detailData.tableAccount.tooltip}
              />
            </Grid>
            <Grid className="m-0 p-0 py-5 px-4 d-flex justify-content-center align-items-center border-top border-neutral-alfa-15">
              <StyledButton
                disabled={false}
                onClick={closeModalVoucherDetail}
                color="secondary"
                variant="default"
              >
                ¡Entendido!
              </StyledButton>
            </Grid>
          </section>
        </Modal>
      )}
    </section>
  );
};

CardVoucher.defaultProps = {
  accountCreationDate: '',
  isMobileDevice: false,
  onScrollTo: () => null,
  onDownloadContracts: () => null,
  onDownloadComponentPdf: () => null,
  onCallSurvey: () => null,
};
CardVoucher.propTypes = {
  accountCreationDate: PropTypes.string,
  isMobileDevice: PropTypes.bool,
  onScrollTo: PropTypes.func,
  onDownloadContracts: PropTypes.func,
  onDownloadComponentPdf: PropTypes.func,
  onCallSurvey: PropTypes.func,
};

export default CardVoucher;
